import { canonicalRepoKeyOf } from "../../projectGroupRoute";
interface SavedRuntimeIdentity {
  readonly runtime: { readonly id: string };
  readonly projects: readonly {
    readonly projectId: string;
    readonly title: string;
    readonly githubRepoFullName?: string | null;
    readonly threads: readonly { readonly threadId: string; readonly title: string }[];
  }[];
}

export interface SavedProjectBreadcrumbIdentity {
  readonly projectId: string;
  readonly projectName: string;
  readonly repository: string | null;
  readonly threadTitle?: undefined;
}

export function resolveSavedThreadBreadcrumb(
  runtimes: readonly SavedRuntimeIdentity[],
  runtimeId: string | null,
  threadId: string | null,
) {
  const runtime = runtimes.find((candidate) => candidate.runtime.id === runtimeId);
  const project = runtime?.projects.find((candidate) =>
    candidate.threads.some((thread) => thread.threadId === threadId),
  );
  const thread = project?.threads.find((candidate) => candidate.threadId === threadId);
  return project && thread
    ? {
        projectId: project.projectId,
        projectName: project.title,
        threadTitle: thread.title,
        repository: project.githubRepoFullName ?? null,
      }
    : null;
}

/** Resolves a pre-thread draft's project from the passive runtime inventory. */
export function resolveSavedDraftBreadcrumb(
  runtimes: readonly SavedRuntimeIdentity[],
  runtimeId: string | null,
  projectId: string | null,
): SavedProjectBreadcrumbIdentity | null {
  const runtime = runtimes.find((candidate) => candidate.runtime.id === runtimeId);
  const project = runtime?.projects.find((candidate) => String(candidate.projectId) === projectId);
  return project
    ? {
        projectId: project.projectId,
        projectName: project.title,
        repository: project.githubRepoFullName ?? null,
      }
    : null;
}

export function savedBreadcrumbProjectRouteKey(
  identity: { readonly repository: string | null } | null,
  liveProjectRouteKey: string | null = null,
): string | null {
  if (liveProjectRouteKey !== null) return liveProjectRouteKey;
  return identity?.repository ? canonicalRepoKeyOf(`github.com/${identity.repository}`) : null;
}
